<template>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-mb-4">
    <div class="tw-flex tw-justify-center tw-items-center tw-gap-1">
      <img alt="titan logo" :src="src" class="tw-w-12 tw-block" />
      Powered by<span class="tw-flex tw-font-bold tw-gap-1">
        CyberSentriq AI
        <cb-icon-ai :width="20" :height="20"
      /></span>
    </div>
  </div>
</template>

<script setup lang="ts">
const src = new URL("@/assets/branding/TitanIcon.svg", import.meta.url).href;
</script>
